import { useRecoilValueLoadable } from 'recoil';
import { DropDownButton } from 'components';
import { useAccountParam } from 'hooks';
import { filteredMarDisputeTypes } from 'state';
import { MarDisputeType } from 'types';
import { useResolvedDropdownItems } from '../DisputeReasonFilter/useResolvedDropdownItems';

export interface MarDisputeTypeFilterProps {
    marDisputeTypeId?: number,
    onMarDisputeTypeIdChange: (value?: number) => void,
}

const DefaultOption = {
    description: 'All'
};

const MarDisputeTypeFilter = ({marDisputeTypeId, onMarDisputeTypeIdChange} : MarDisputeTypeFilterProps) => {
    const accountId = useAccountParam();
    const itemsLoadable = useRecoilValueLoadable(filteredMarDisputeTypes(accountId));
    const items = useResolvedDropdownItems<MarDisputeType>(accountId, itemsLoadable);
    
    return (
        <DropDownButton
            items={[DefaultOption, ...items]}
            text={`Dispute type: ${items.find((item) => item.marDisputeTypeId === marDisputeTypeId)?.description ?? 'All'}`}
            onItemClick={(e) => onMarDisputeTypeIdChange(e.item.marDisputeTypeId)}
            textField="description"
        />
    );
}

export default MarDisputeTypeFilter;
